import React from 'react';
import { Download, Video, Presentation } from 'lucide-react';
import talks from '../talks.json';

const Talk = ({ talk }) => {
  const getFilePath = (file) => {
    return file.startsWith('http') ? file : `${process.env.PUBLIC_URL}/${file}`;
  };

  return (
    <div className="grid grid-cols-1 sm:grid-cols-[4rem_1fr] gap-x-6 gap-y-1 py-6 border-b border-zinc-100 last:border-0">
      <div className="hidden sm:block font-mono text-sm text-zinc-400 pt-1">{talk.year}</div>
      <div className="min-w-0">
        <h3 className="text-[1.05rem] font-semibold leading-snug">{talk.title}</h3>
        <p className="text-[0.9rem] text-zinc-500 mt-1">{talk.venue}<span className="sm:hidden">, {talk.year}</span></p>

        <div className="flex flex-wrap gap-2 mt-3">
          {talk.pdf && (
            <a href={getFilePath(talk.pdf)} target="_blank" rel="noopener noreferrer" className="chip">
              <Download size={14} /> PDF
            </a>
          )}
          {talk.video && (
            <a href={talk.video} target="_blank" rel="noopener noreferrer" className="chip">
              <Video size={14} /> Video
            </a>
          )}
          {talk.slides && (
            <a href={getFilePath(talk.slides)} target="_blank" rel="noopener noreferrer" className="chip">
              <Presentation size={14} /> Slides
            </a>
          )}
        </div>
        
        {talk.summary && <p className="mt-3 text-zinc-600">{talk.summary}</p>}
      </div>
    </div>
  );
};

const TalksList = () => {
  return (
    <div>
      <h1 className="page-title mb-10">Talks</h1>
      {talks.map((talk, index) => (
        <Talk key={index} talk={talk} />
      ))}
    </div>
  );
};

export default TalksList;
